import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Planet"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-planet',
    templateUrl: './icon-planet.component.html',
    styleUrls: ['./icon-planet.component.scss'],
    standalone: false
})
export class IconPlanetComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
